import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { EmptyAlert } from 'static/constants'
import * as Actions from 'actions/alerts'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  alerts: {},
  history: [],
  previewActions: [],
  previewCondition: {},
  previewResults: [],
  removeAlert: EmptyAlert
})

const addAlertsToState = alerts => fromJS({}).withMutations(ctx => {
  alerts.forEach(alert => ctx.set(alert.get('id').toString(), alert))
})

const updateAlertsInState = (state, alerts) => state.withMutations(ctx => {
  fromJS(alerts).forEach(alert => ctx.set(alert.get('id').toString(), alert))
})

const deleteAlertsFromState = (state, alertIds) => state.withMutations(ctx => {
  fromJS(alertIds).forEach(alertId => ctx.delete(alertId.toString()))
})

export default handleActions({
  [Actions.fetchAlertsSuccess]: (state, { payload: alerts }) => state.set('alerts', addAlertsToState(fromJS(alerts))),
  [Actions.fetchAlertHistorySuccess]: (state, { payload: history }) => state.set('history', fromJS(history)),
  [Actions.previewAlertStart]: (state, { payload: alert }) => state
    .set('previewActions', alert.get('actions') || fromJS([]))
    .set('previewCondition', alert.get('condition') || fromJS({}))
    .set('previewResults', fromJS([])),
  [Actions.previewAlertSuccess]: (state, { payload: results }) => state.set('previewResults', fromJS(results)),
  [Actions.hideAlertPreviewDialog]: state => state
    .set('previewActions', fromJS([]))
    .set('previewCondition', fromJS({}))
    .set('previewResults', fromJS([])),
  [Actions.showRemoveAlertDialog]: (state, { payload: alert }) => state.set('removeAlert', alert),
  [Actions.hideRemoveAlertDialog]: state => state.set('removeAlert', initialState.get('removeAlert')),
  [Actions.saveAlertSuccess]: (state, { payload: alert }) => state.setIn(['alerts', alert.id.toString()], fromJS(alert)),
  [Actions.updateAlertsStatusSuccess]: (state, { payload: alerts }) => state.update(
    'alerts',
    alertState => updateAlertsInState(alertState, alerts)
  ),
  [Actions.deleteAlertSuccess]: (state, { payload: alertId }) => state.deleteIn(['alerts', alertId.toString()]),
  [Actions.deleteAlertsSuccess]: (state, { payload: alertIds }) => state.update(
    'alerts',
    alertState => deleteAlertsFromState(alertState, alertIds)
  ),
  [AppActions.resetState]: () => initialState
}, initialState)
